export default __webpack_public_path__ + "static/hero_footer-c8cb01268ebb60d89582a9a58a06e6bd.svg";